// extracted by mini-css-extract-plugin
export var phone = "_49-0";